export default __webpack_public_path__ + "static/media/down.074f35f4.svg";